import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

/**
 * Supabase client: sign-up, sign-in, codes and realtime only. Everything that
 * writes goes through the API ({@link ./api.ts}).
 */
export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      storageKey: 'tarmx-session',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
  },
)

/**
 * The access token of the session, refreshed first when it is about to expire.
 * @returns The token, or `null` when signed out.
 */
export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}
